import { IMakeCallAdapter } from '@webex/component-adapter-interfaces/dist/esm/src';
import { makeCrossLaunchCall } from '../ms-teams-sdk/service/CrossLaunchService';

export class MsTeamsMakeCallAdapter implements IMakeCallAdapter {
  makeCall(address: string, isVideo: boolean): Promise<void> {
    return makeCrossLaunchCall(address, !isVideo);
  }
}
